import React, { useEffect, useState } from "react";
import TestMatchTabs from "../cricket/TestMatchTabs";
import CommentaryByOver from "./CommentaryByOver";
import Loader from "../common/Loader";
import { loadStyles } from "../../utils/cssLoader";
const CricketCommentaryWrap = ({ ServerData,
  matchId,
  loadCSS = true,
  dataClient = false,
  baseUrl,
  title, }) => {


  const [clientData, setClientData] = useState(null);
  const tabsData = dataClient ? clientData?.data : ServerData?.data;


  useEffect(() => {
    if (!dataClient) return;
    const container = document?.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data;
      setClientData(parsed || null);

    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);

  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("cricketmatch");
    }
  }, [loadCSS]);


  const items = tabsData?.map((item) => ({
    label: item?.cap,
    value: item?.ord,
  }));
  const [activeItem, setActiveItem] = useState(null);
  const [commentaryData, setCommentaryData] = useState({});
  const [pageCount, setPageCount] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  const handleLoadMore = async () => {
    try {
      const res = await fetch(
        `${baseUrl}/cricket/match/${matchId}/commentary?page=${pageCount + 1}&inning=${activeItem}`
      );
      const data = await res.json();

      setCommentaryData((prevState) => ({
        ...prevState,
        data: [...(prevState?.data || []), ...data.data],
        metadata: data.metadata,
      }));

      setPageCount((prevPage) => prevPage + 1);
    } catch (err) {
      console.error("Failed to load more commentary:", err);
    }
  };
  useEffect(() => {
    if (!activeItem) return;
    setIsLoading(true);
    async function fetchData() {
      const newData = await fetch(
        `${baseUrl}/cricket/match/${matchId}/commentary?inning=${activeItem}`
      );
      const data = await newData.json();
      setCommentaryData(data);
      setIsLoading(false);


    }

    fetchData();
  }, [activeItem]);
  useEffect(() => {
    if (!activeItem && items?.length) {
      setActiveItem(items.at(-1).value);
      setPageCount(1);
    }
  }, [items]);
  return (
    <>
      <TestMatchTabs
        items={items}
        activeItem={activeItem}
        onClick={setActiveItem}
      />
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <CommentaryByOver
            data={commentaryData?.data || []}
            selectedInnings={activeItem}
          />
          {commentaryData?.metadata?.pagination?.last_page > pageCount ? (
            <div className="text_center">
              <button
                className="button button_primary"
                onClick={() => handleLoadMore()}
              >
                Load More
              </button>
            </div>
          ) : null}
        </>
      )}
    </>


  );
};

export default CricketCommentaryWrap;
